import * as React from 'react';

import Tabs from 'antd/lib/tabs';
import {Link} from 'react-router-dom';

import { Loading } from '@common/react/components/UI/Loading/Loading';

import {rest} from '@app/components/Api';
import memorialPackageImg from '@app/content/memorial-package.jpg';
import AreaHeader from '@app/components/UI/Area-blocks/AreaHeader/AreaHeader';
import CardPhoto from '@app/components/UI/CardPhoto/CardPhoto';
import AreaServicePattern from '@app/components/UI/Area-blocks/AreaServicePattern/AreaServicePattern';
import AreaServicesCommonInfo from '@app/components/UI/Area-blocks/AreaServicesCommonInfo/AreaServicesCommonInfo';
import {AreaService} from '@app/objects/AreaService';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import NavSelectMobile from '@app/components/UI/NavSelectMobile/NavSelectMobile';
import MailingAddress from '@app/components/UI/Area-blocks/AreaServices/MailingAddress';

const navItems = [
	{name: '0', title: 'Euthanasia'},
	{name: '1', title: 'Aftercare & Cremation\n'},
	{name: '2', title: 'Veterinary Hospice & Telehospice'},
];

const AreaServices = (props) => {
	const {area} = props;
	const {TabPane} = Tabs;

	const [service, setService] = React.useState<AreaService>();
	const [currentIndex, setCurrentIndex] = React.useState('0');

	const clickOnAftercare = () => {
		setCurrentIndex('1');
		document.querySelector('.area-services div[role="tablist"]')?.scrollIntoView();
	};

	React.useEffect(() => {
		rest.get<AreaService>(`v1/areas/${area.id}/services`)
			.then(res => setService(res));
	}, []);

	const onItemSelect = (e) => {
		setCurrentIndex(e.toString());
	};

	return (
		<div className="area">
			<AreaHeader area={area}/>
			<NavSelectMobile
				navItems={navItems}
				onChange={onItemSelect}
				currentIndex={currentIndex}
			/>
			{!service ? <Loading /> :
				<>
					<Tabs
						className="area-services"
						activeKey={currentIndex}
						onTabClick={(key, event) => {
							setCurrentIndex(key);
						}}
					>
						<TabPane tab="Euthanasia" key="0">
							<AreaServicePattern
								title="Euthanasia appointment"
								description={service?.euthanasiaDescription}
								textLink="Learn more about euthanasia"
								textLinkUrl="/our-services/in-home-euthanasia"
								fees={[{ caption: 'Appointment Base Pricing', price: service?.euthanasiaPricing }]}
								pricePostscript={<>*Additional fees may apply including <span className="link" onClick={clickOnAftercare}>aftercare</span></>}
							/>
							<CardPhoto
								imgURL={memorialPackageImg}
								title={'A look at our pet memorial package.'}
							/>

							<AreaServicesCommonInfo additionalServices={service?.additionalServices} />
						</TabPane>

						<TabPane tab="Aftercare & Cremation" key="1">
							<AreaServicePattern
								title="Private cremation"
								description={service?.privateCremationDescription}
								textLink="Learn more about aftercare"
								textLinkUrl="/our-services/aftercare"
								fees={service?.privateCremation?.map((cremation) => {
									return {
										price: cremation.fee,
										caption: `Pets ${cremation.minWeight ? `${cremation.minWeight} -` : 'up to'} ${cremation.maxWeight} pounds`
									};
								})}
							/>
							<AreaServicePattern
								title="Communal cremation"
								description={service?.communalCremationDescription}
								textLink="Learn more about aftercare"
								textLinkUrl="/our-services/aftercare"
								fees={service?.communalCremation?.map((cremation) => {
									return {
										price: cremation.fee,
										caption: `Pets ${cremation.minWeight ? `${cremation.minWeight} -` : 'up to'} ${cremation.maxWeight} pounds`
									};
								})}
							/>

							<AreaServicesCommonInfo
								additionalServices={service?.additionalServices}
								customReplacements={[{name: 'Additional fees', description: service?.aftercareAdditionalFees || ''}]}
							/>
						</TabPane>

						<TabPane tab="Veterinary Hospice & Telehospice" key="2">
							<AreaServicePattern
								title="Veterinary hospice appointment"
								description={service?.hospiceDescription}
								textLink="Learn more about veterinary hospice"
								textLinkUrl="/our-services/veterinary-hospice"
								fees={[{caption: 'Appointment Base Pricing', price: service?.hospicePricing}]}
								pricePostscript={<>*Additional fees may apply including <span className="link" onClick={clickOnAftercare}>aftercare</span></>}
							/>
							<AreaServicePattern
								title="Telehospice appointment"
								description={service?.teleadviceDescription}
								textLink="Learn more about telehospice"
								textLinkUrl="/our-services/telehospice"
								fees={[{caption: 'Appointment Base Pricing', price: service?.teleadvicePricing}]}
								pricePostscript={<>*Additional fees may apply including <span className="link" onClick={clickOnAftercare}>aftercare</span></>}
							/>

							<AreaServicesCommonInfo additionalServices={service?.additionalServices}/>
						</TabPane>
					</Tabs>

					{service?.paymentOptions && <MiddleText title="Payment options" text={service.paymentOptions}/>}

					<MailingAddress area = {area}/>
				</>
			}
		</div>
	);
};

export default AreaServices;